<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__accessmanagementlog}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
       <el-form-item label="">
          <wPickers v-model="dateValue" @input="getTimes"></wPickers>
        </el-form-item>
        <!-- <el-form-item>
          <wList
            v-model="dataForm.company"
            dataUrl="/sys/channels/list"
            placeholder="平台"
          ></wList>
        </el-form-item> -->
        
        <el-form-item>
          <renSelect
            v-model="dataForm.product"
            dictType="loan_type"
            originPage="put"
            placeholder="产品"
          ></renSelect>
        </el-form-item>

        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
            <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button v-if="$hasPermission('sys:accessmanagementlog:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button v-if="$hasPermission('sys:accessmanagementlog:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
          </el-form-item> -->
      </el-form>
      <!-- <div class="balance">账户余额：10000元</div> -->
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%"
        @sort-change="dataListSortChangeHandle($event,false)"
      >
        <el-table-column
          prop="reportDate"
          label="日期"
          header-align="center"
          align="center"
          sortable="custom"
        >
        <template slot-scope="scope">
          <div>
            {{scope.row.reportDate.split(' ')[0]}}
          </div>
        </template>
      </el-table-column>
        <el-table-column
          prop="trafficPlatformName"
          label="媒体平台"
          header-align="center"
          align="center"
       
        ></el-table-column>
        <el-table-column
          prop="productName"
          label="产品"
          header-align="center"
          align="center"
        
        ></el-table-column>
        <el-table-column
          prop="city"
          label="城市"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="clueSum"
          label="投放线索数量"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="clueActualSum"
          label="实际线索数量"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="yingshuAccountAmount"
          label="祁浩账户数量"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="revenue"
          label="成本单价"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
    </div>
  </el-card>
</template>
  
  <script>
import mixinViewModule from "@/mixins/view-module";

export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/sys/costreport/page",
        getDataListIsPage: true,
        exportURL: "/sys/costreport/export",
        deleteURL: "/sys/costreport",
        deleteIsBatch: true,
      },
      dateValue: "",
     
      dataForm: {
        id: "",
        product: "",
        startDate: "",
        endDate: "",
       
      },
    };
  },
  mounted() {
   
  },
  methods: {
    getTimes() {
      if (this.dateValue != null) {
        this.dataForm.startDate = this.dateValue[0];
        this.dataForm.endDate = this.dateValue[1];
      } else {
        delete this.dataForm.startDate 
        delete this.dataForm.endDate
      }
    },
    
  },
  components: {},
};
</script>
<style>
.balance{
  margin-bottom: 10px;
  color: red;
}
</style>
  
  